// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import { node } from 'prop-types';
import { createContext } from 'use-context-selector';
import noop from 'lodash/noop';

export const BreadcrumbsContext = createContext({
  breadcrumbs: {},
  setBreadcrumbs: noop
});

const BreadcrumbsProvider = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState({});
  return (
    <BreadcrumbsContext.Provider value={{ ...breadcrumbs, setBreadcrumbs }}>
      { children }
    </BreadcrumbsContext.Provider>
  );
};

BreadcrumbsProvider.propTypes = {
  children: node
};

BreadcrumbsProvider.displayName = 'BreadcrumbsProvider';

export default BreadcrumbsProvider;
